export default class Sistema {

    constructor(nomeSistema='', nomeArea='', codigoArea='', contexto='') {
        this.nomeSistema = nomeSistema;
        this.nomeArea = nomeArea;
        this.codigoArea = codigoArea;
        this.contexto = contexto;
        this.perfilPadrao = undefined;
        this.perfisSelecionados = [];
    }

    obterPerfilSelecionado(perfis) {
        const self = this;
        if(self.perfisSelecionados.length){
            for (let i = 0; i < self.perfisSelecionados.length; i++){
                let p = self.perfisSelecionados[i],
                    perfil = perfis.find(pe => pe.numero === p.numero);
                if(perfil) return perfil;
            }
        }
        return self.perfilPadrao ? perfis.find(p => p.numero === self.perfilPadrao.numero) || perfis[0] : perfis[0];
    }

    selecionarPerfil(perfil) {
        let index = this.perfisSelecionados.findIndex(p => p.numero === perfil.numero);
        if(index !== -1){
            let aux = this.perfisSelecionados[0];
            this.perfisSelecionados[0] = perfil;
            this.perfisSelecionados[index] = aux;
        } else {
            this.perfisSelecionados.unshift(perfil);
        }
    }

}